import React, {useState, useEffect, useRef} from 'react';
import {
    EditorState,
    RichUtils,
} from 'draft-js';
import Dropdown from '../../../../bootstrap/components/dropdown/Dropdown';
import LinkForm from '../forms/link/LinkForm';

export default function useLink(editorState, setEditorState) {
    const [dialogShown, setDialogShown] = useState(false);

    const [linkInfo, setLinkInfo] = useState({});

    const buttonRef = useRef();

    useEffect(() => {
        if (Object.keys(linkInfo).length > 0) {
            updateLinkIfExists() || createNewLink();
        }
    }, [linkInfo]);

    const updateLinkIfExists = () => {
        const linkKey = getLinkKeyAtSelection();
        if (linkKey === null) {

            return false;
        }

        const contentState = editorState.getCurrentContent();
        contentState.replaceEntityData(linkKey, linkInfo);

        return true;
    };

    const createNewLink = () => {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'LINK',
            'MUTABLE',
            linkInfo
        );
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, {currentContent: contentStateWithEntity});

        setEditorState(RichUtils.toggleLink(
            newEditorState,
            newEditorState.getSelection(),
            entityKey
        ));
    };

    const getLinkKeyAtSelection = () => {
        const selection = editorState.getSelection();
        const startKey = selection.getStartKey();
        const startOffset = selection.getStartOffset();

        const contentState = editorState.getCurrentContent();
        const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);

        return blockWithLinkAtBeginning.getEntityAt(startOffset);
    };

    const getLinkInfoAtSelection = () => {
        const linkKey = getLinkKeyAtSelection();

        if (linkKey) {
            const contentState = editorState.getCurrentContent();
            const linkInstance = contentState.getEntity(linkKey);
            return linkInstance.getData();
        }

        const selectionState = editorState.getSelection();
        const anchorKey = selectionState.getAnchorKey();
        const currentContent = editorState.getCurrentContent();
        const currentContentBlock = currentContent.getBlockForKey(anchorKey);
        const start = selectionState.getStartOffset();
        const end = selectionState.getEndOffset();
        const selectedText = currentContentBlock.getText().slice(start, end);

        return {
            text: selectedText
        };
    };

    const linkButton = <button
        type="button"
        ref={buttonRef}
        onMouseDown={ev => {
            ev.preventDefault();
            getLinkInfoAtSelection();
            setDialogShown(true);
        }}
        disabled={getLinkKeyAtSelection() === null && editorState.getSelection().isCollapsed()}
    >
        Link
    </button>;

    const linkDialog = !dialogShown ? null
        : <Dropdown
        close={() => setDialogShown(false)}
        opener={buttonRef.current}
        horizontalAlignment="center"
        isPointerEnabled={true}
    >
        <LinkForm
            initialLinkInfo={getLinkInfoAtSelection()}
            onDone={linkInfo => {
                setLinkInfo(linkInfo);
                setDialogShown(false);
            }}
            onCancel={() => setDialogShown(false)}
        />
    </Dropdown>;

    return [
        linkButton,
        linkDialog,
    ];
}

